import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-not-exist-data',
  templateUrl: './not-exist-data.component.html',
  styleUrls: ['./not-exist-data.component.scss']
})
export class NotExistDataComponent implements OnInit {

  @Input()
  activityType!: string;

  ngOnInit(): void {
    console.log("NotExistDataComponent");
  }
}
